import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1288cf30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-accreditation-manager" }
const _hoisted_2 = {
  key: 0,
  class: "text-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "row mb-4" }
const _hoisted_8 = { class: "col-sm-12" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Add New Accreditation", -1))
const _hoisted_10 = { class: "search-input" }
const _hoisted_11 = { class: "list-container mt-3" }
const _hoisted_12 = {
  key: 0,
  class: "text-center text-muted"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "name" }
const _hoisted_15 = { class: "mt-2" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-sm-12" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Current Accreditations", -1))
const _hoisted_21 = {
  key: 0,
  class: "text-muted text-center"
}
const _hoisted_22 = {
  key: 1,
  class: "list-group"
}
const _hoisted_23 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_24 = { class: "mb-1" }
const _hoisted_25 = { class: "mb-1" }
const _hoisted_26 = { class: "text-muted ms-2" }
const _hoisted_27 = {
  key: 0,
  class: "mb-1 text-muted"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]

import { ref, onMounted, watch } from 'vue';
import axios from 'axios';
import { Modal } from 'uiv';

interface OrganisationListItemApiModel {
  id: string;
  name: string;
}

interface AccreditationApiModel {
  id: number;
  organisationId: string;
  organisationName: string;
  role: string;
  grantedDate: string;
  notes?: string;
}


export default /*#__PURE__*/_defineComponent({
  ...{ name: 'UserAccreditationManager' },
  __name: 'user-accreditation-manager',
  props: {
    userId: {}
  },
  setup(__props: any) {



const props = __props;

const showModal = ref(false);
const isLoading = ref(false);
const isSearching = ref(false);
const error = ref<string | null>(null);
const accreditations = ref<AccreditationApiModel[]>([]);
const searchText = ref('');
const allOrganisations = ref<OrganisationListItemApiModel[]>([]);
const searchResults = ref<OrganisationListItemApiModel[] | null>(null);
const selectedOrganization = ref<OrganisationListItemApiModel | null>(null);
const serverCallTimeout = ref<any>(null);

const loadOrganisations = async () => {
  try {
    const response = await axios.get('/api/admin/organisations');
    allOrganisations.value = response.data.map((org: any) => ({
      id: org.id,
      name: org.name
    }));
    performSearch(); // Initial search with empty query to show all available orgs
  } catch (err) {
    error.value = 'Failed to load organizations';
    console.error('Error loading organizations:', err);
  }
};

const loadAccreditations = async () => {
  try {
    isLoading.value = true;
    error.value = null;
    const response = await axios.get(`/api/admin/useraccreditations/${props.userId}`);
    accreditations.value = response.data.map((acc: any) => ({
      id: acc.id,
      organisationId: acc.organisationId,
      organisationName: acc.organisationName,
      role: acc.role,
      grantedDate: acc.grantedDate,
      notes: acc.notes
    }));
  } catch (err) {
    error.value = 'Failed to load accreditations';
    console.error('Error loading accreditations:', err);
  } finally {
    isLoading.value = false;
  }
};

const performSearch = () => {
  if (!allOrganisations.value.length) {
    searchResults.value = null;
    return;
  }

  const query = searchText.value.trim().toLowerCase();
  const existingOrgIds = accreditations.value.map(a => a.organisationId);
  
  // Filter organizations based on search text and exclude already accredited ones
  searchResults.value = allOrganisations.value.filter(
    org => !existingOrgIds.includes(org.id) && 
    (query === '' || org.name.toLowerCase().includes(query))
  );
};

const selectOrganization = (org: OrganisationListItemApiModel) => {
  selectedOrganization.value = org;
};

const accreditOrganization = async (org: OrganisationListItemApiModel, role: string) => {
  try {
    await axios.post('/api/admin/useraccreditation', {
      userId: props.userId,
      organisationId: org.id,
      accreditationRole: role,
      notes: ''
    });
    await loadAccreditations();
    performSearch(); // Refresh the available organizations list
  } catch (err) {
    error.value = 'Failed to add accreditation';
    console.error('Error adding accreditation:', err);
  }
};

const updateAccreditation = async (accreditation: AccreditationApiModel) => {
  const newRole = accreditation.role === 'Accredited' ? 'SuperAccredited' : 'Accredited';
  try {
    await axios.post('/api/admin/useraccreditation', {
      userId: props.userId,
      organisationId: accreditation.organisationId,
      accreditationRole: newRole,
      notes: accreditation.notes || ''
    });
    await loadAccreditations();
  } catch (err) {
    error.value = 'Failed to update accreditation';
    console.error('Error updating accreditation:', err);
  }
};

const removeAccreditation = async (accreditation: AccreditationApiModel) => {
  if (!confirm('Are you sure you want to remove this accreditation?')) {
    return;
  }

  try {
    await axios.post('/api/admin/useraccreditation', {
      userId: props.userId,
      organisationId: accreditation.organisationId
    });
    await loadAccreditations();
    performSearch(); // Refresh the available organizations list
  } catch (err) {
    error.value = 'Failed to remove accreditation';
    console.error('Error removing accreditation:', err);
  }
};

const formatDate = (date: string) => {
  return new Date(date).toLocaleDateString();
};

watch(searchText, () => {
  performSearch();
});

watch(showModal, (newValue) => {
  if (newValue) {
    loadAccreditations();
    loadOrganisations();
  }
});

onMounted(() => {
  loadAccreditations();
  loadOrganisations();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn btn-primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = true))
    }, " Manage Accreditations "),
    _createVNode(_unref(Modal), {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showModal).value = $event)),
      title: "Manage User Accreditations",
      size: "lg"
    }, {
      default: _withCtx(() => [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
          : (error.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(error.value), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _withDirectives(_createElementVNode("input", {
                        type: "search",
                        class: "form-control",
                        placeholder: "Search organizations...",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchText).value = $event)),
                        "aria-label": "Search organizations"
                      }, null, 512), [
                        [_vModelText, searchText.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      (!searchResults.value || searchResults.value.length === 0)
                        ? (_openBlock(), _createElementBlock("h4", _hoisted_12, _toDisplayString(searchText.value ? 'No matching organizations found.' : 'No organizations available for accreditation.'), 1))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.value, (org) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: org.id,
                          class: _normalizeClass(["organization-list-item", { selected: org === selectedOrganization.value }]),
                          onClick: ($event: any) => (selectOrganization(org))
                        }, [
                          _createElementVNode("span", _hoisted_14, _toDisplayString(org.name), 1),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("button", {
                              class: "btn btn-sm btn-primary me-2",
                              onClick: _withModifiers(($event: any) => (accreditOrganization(org, 'Accredited')), ["stop"])
                            }, " Accredit ", 8, _hoisted_16),
                            _createElementVNode("button", {
                              class: "btn btn-sm btn-success",
                              onClick: _withModifiers(($event: any) => (accreditOrganization(org, 'SuperAccredited')), ["stop"])
                            }, " Super Accredit ", 8, _hoisted_17)
                          ])
                        ], 10, _hoisted_13))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    (accreditations.value.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, " No accreditations found for this user "))
                      : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accreditations.value, (accreditation) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: accreditation.id,
                              class: "list-group-item"
                            }, [
                              _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("h5", _hoisted_24, _toDisplayString(accreditation.organisationName), 1),
                                  _createElementVNode("p", _hoisted_25, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["badge", accreditation.role === 'SuperAccredited' ? 'bg-success' : 'bg-primary'])
                                    }, _toDisplayString(accreditation.role), 3),
                                    _createElementVNode("small", _hoisted_26, " Granted: " + _toDisplayString(formatDate(accreditation.grantedDate)), 1)
                                  ]),
                                  (accreditation.notes)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_27, [
                                        _createElementVNode("small", null, _toDisplayString(accreditation.notes), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-outline-primary me-2",
                                    onClick: ($event: any) => (updateAccreditation(accreditation))
                                  }, _toDisplayString(accreditation.role === 'Accredited' ? 'Change to SuperAccredited' : 'Change to Accredited'), 9, _hoisted_28),
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-outline-danger",
                                    onClick: ($event: any) => (removeAccreditation(accreditation))
                                  }, " Remove ", 8, _hoisted_29)
                                ])
                              ])
                            ]))
                          }), 128))
                        ]))
                  ])
                ])
              ]))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})